import { navLinks } from "@/mocks/homeData";

export default function SiteFooter() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <footer className="w-full bg-secondary-900 text-secondary-100">
      <div className="mx-auto w-full max-w-6xl px-4 py-14 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-play-circle-fill text-lg"></i>
              </span>
              <span className="font-heading text-base font-bold text-background-50">继母的诱惑 · 观看指南</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-secondary-200">
              本页汇总「继母的诱惑」相关的观看渠道类型、资源导航与查找思路，帮助你更快找到稳定可用的观看入口。
            </p>
          </div>

          <div className="md:col-span-4">
            <h3 className="text-xs font-semibold tracking-[0.2em] text-secondary-300">页面导航</h3>
            <ul className="mt-5 grid grid-cols-2 gap-x-6 gap-y-3">
              {navLinks.map((link) => (
                <li key={link.id}>
                  <a
                    href={`#${link.id}`}
                    onClick={(e) => {
                      e.preventDefault();
                      scrollTo(link.id);
                    }}
                    className="text-sm text-secondary-200 transition-colors hover:text-background-50"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <h3 className="text-xs font-semibold tracking-[0.2em] text-secondary-300">站点说明</h3>
            <ul className="mt-5 space-y-3 text-sm text-secondary-200">
              <li className="flex items-center gap-2">
                <i className="ri-shield-check-line text-accent-400"></i>
                仅做渠道信息整理
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-file-forbid-line text-accent-400"></i>
                不提供任何影片文件
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-user-voice-line text-accent-400"></i>
                请在合法合规前提下观看
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 rounded-xl border border-secondary-800 bg-secondary-950/40 p-5 md:p-6">
          <h3 className="flex items-center gap-2 text-sm font-semibold text-background-50">
            <i className="ri-copyright-line text-accent-400"></i>
            版权与免责声明
          </h3>
          <p className="mt-3 text-xs leading-relaxed text-secondary-300 md:text-sm">
            本页内容仅为公开信息的整理与导航，不存储、不制作、不传播任何影视作品及其文件。
            页面中出现的名称、描述与渠道类型均用于说明观看方向。相关影视内容的著作权归其权利人所有，
            请通过合法渠道观看。若本页信息涉及你的权益，请与我们联系，我们会及时处理。
          </p>
        </div>

        <div className="mt-8 flex flex-col items-start justify-between gap-3 border-t border-secondary-800 pt-6 text-xs text-secondary-400 sm:flex-row sm:items-center">
          <p>© {new Date().getFullYear()} 继母的诱惑 · 观看指南与资源导航</p>
          <p>页面信息仅供参考，具体以你实际打开的平台为准。</p>
        </div>
      </div>
    </footer>
  );
}